/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Submit_FailedInputs */

const vi_carrier_form_submit_failed = /** @type {(inputs: Carrier_Form_Submit_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo vận đơn thất bại`)
};

/**

* @param {Carrier_Form_Submit_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_submit_failed = /** @type {((inputs?: Carrier_Form_Submit_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Submit_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_submit_failed(inputs)
});